import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../../../core/api/apiTypes"
import { NewSupportCreateSupplier, SupplierWithHistory } from "./supplierTypes"

type FetchEntityByIdParams = Readonly<{
    entityId: number
}>

export async function fetchEntitiesById(
    { entityId }: FetchEntityByIdParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierWithHistory> {
    const url = `/entities/${entityId}`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function createSupplierApi(
    { entity }: NewSupportCreateSupplier,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = "/suppliers"

    const response = await axios.post(
        url,
        {
            entity,
        },
        {
            signal,
        },
    )

    return response.data
}

export async function updateSupplierApi(
    { entityId, entity }: { entityId: string; entity: NewSupportCreateSupplier["entity"] },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/entities/${entityId}`

    const response = await axios.post(
        url,
        {
            entity,
        },
        {
            signal,
        },
    )

    return response.data
}
